import { throwError } from 'rxjs';

import GatewayBase from './gateway-base';
import { Orders } from '@database/types';
import type { ThemeBranding } from '@monolog/shared/types';

export type InventoryQuantity = {
  id: string;
  variantId: string;
  inStock: boolean;
  continueSelling: boolean;
  inventoryQuantity: number;
  status?: Orders.ProductStatus;
};

export type ExchangeRate = {
  currency: string;
  exchangeRate: number;
};

export class PlatformsService extends GatewayBase {
  get shopify() {
    return {
      confirmRequestReinstall: this.confirmRequestReinstall,
      exchangeRate: this.getShopifyExchangeRate,
      inventory: this.getShopifyInventory,
      metadata: this.getShopifyMetadata,
      requestReinstall: this.requestShopifyReinstall,
      themeBranding: this.getShopifyThemeBranding,
    };
  }

  get bigcommerce() {
    return {
      exchangeRate: () => throwError(() => new Error('this is not supported')),
      inventory: this.getBigcommerceInventory,
      metadata: () => throwError(() => new Error('this is not supported by our BigCommerce integration')),
    };
  }

  private getBigcommerceInventory = (storeId: string, sourceOrderId: string) => {
    return this.client.get<InventoryQuantity[]>(`v1/bigcommerce/${storeId}/${sourceOrderId}/inventory`);
  };

  private getShopifyInventory = (storeId: string, sourceOrderId: string) => {
    return this.client.get<InventoryQuantity[]>(`v1/shopify/${storeId}/${sourceOrderId}/inventory`);
  };

  private getShopifyExchangeRate = (storeId: string, sourceOrderId: string) => {
    return this.client.get<ExchangeRate>(`v1/shopify/${storeId}/${sourceOrderId}/exchange-rate`);
  };

  private getShopifyMetadata = (storeId: string) => {
    return this.client.get<{ currency: string; exchangeRate: number }>(`v1/shopify/${storeId}/metadata`);
  };

  private getShopifyThemeBranding = (storeDomain: string) => {
    return this.client.get<ThemeBranding>(`v1/shopify/theme-branding?store=${storeDomain}`);
  };

  private requestShopifyReinstall = (storeId: string, email: string) => {
    return this.client.post(`v1/platforms/${storeId}/installations`, { email });
  };

  private confirmRequestReinstall = (data: {
    token: string;
    accessToken: string;
    apiKey: string;
    apiSecret: string;
  }) => {
    return this.client.post(`v1/platforms/installations/confirm`, data);
  };
}
